<figure appMapLegend class="legend-container" id="mobile-legend" aria-label="Mobile coverage legend">
  <figcaption class="legend-title">{{ title }}</figcaption>
  @if (isDetailedLegend) {
    <div class="legend-detailed" role="list">
      @for (value of detailedLegend; track value.label) {
        <div class="legend-detailed-item" role="listitem">
          <span class="legend-detailed-swatch" [style.backgroundColor]="value.color"></span>
          <span>{{ value.label | translate }}</span>
        </div>
      }
    </div>
  } @else {
    <div class="legend-byzone" role="img" aria-label="Mobile coverage from zero to one hundred">
      <div class="legend-gradient"></div>
      <div class="legend-labels">
        @for (value of byzoneLegend.values; track value.label) {
          <span>{{ value.label | translate }}</span>
        }
      </div>
    </div>
  }
</figure>